"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _1 = require("./");
var inversify_1 = require("inversify");
var Root = /** @class */ (function () {
    function Root(login, loginSocial, passwordRecovery, register, role, user, permissions, lookups) {
        this.login = login;
        this.loginSocial = loginSocial;
        this.passwordRecovery = passwordRecovery;
        this.register = register;
        this.role = role;
        this.user = user;
        this.permissions = permissions;
        this.lookups = lookups;
    }
    var _a, _b, _c, _d, _e, _f, _g, _h;
    Root = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.LoginClient)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.LoginSocialClient)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.PasswordRecoveryClient)),
        tslib_1.__param(3, inversify_1.inject(_1.TYPES.RegisterClient)),
        tslib_1.__param(4, inversify_1.inject(_1.TYPES.RoleClient)),
        tslib_1.__param(5, inversify_1.inject(_1.TYPES.UserClient)),
        tslib_1.__param(6, inversify_1.inject(_1.TYPES.PermissionClient)),
        tslib_1.__param(7, inversify_1.inject(_1.TYPES.LookupClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.LoginClient !== "undefined" && _1.LoginClient) === "function" ? _a : Object, typeof (_b = typeof _1.LoginSocialClient !== "undefined" && _1.LoginSocialClient) === "function" ? _b : Object, typeof (_c = typeof _1.PasswordRecoveryClient !== "undefined" && _1.PasswordRecoveryClient) === "function" ? _c : Object, typeof (_d = typeof _1.RegisterClient !== "undefined" && _1.RegisterClient) === "function" ? _d : Object, typeof (_e = typeof _1.RoleClient !== "undefined" && _1.RoleClient) === "function" ? _e : Object, typeof (_f = typeof _1.UserClient !== "undefined" && _1.UserClient) === "function" ? _f : Object, typeof (_g = typeof _1.PermissionClient !== "undefined" && _1.PermissionClient) === "function" ? _g : Object, typeof (_h = typeof _1.LookupClient !== "undefined" && _1.LookupClient) === "function" ? _h : Object])
    ], Root);
    return Root;
}());
exports.Root = Root;
